<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-channel-select
        v-model="tableParams.channelId"
        :channelType="100"
      />
      <search-channel-slot-select
        v-model="tableParams.slotId"
        :channelId="tableParams.channelId"
        :deleted="1"
      />
      <search-dsp-select v-model="tableParams.dspId" :dspType="100" />
      <search-dsp-slot-select
        v-model="tableParams.dspSlotId"
        :dsp-id="tableParams.dspId"
        :slot-is-enable="false"
      />
      <el-select
        v-model="tableParams.dspType"
        clearable
        placeholder="请选择DSP类型"

      >
        <el-option label="CPM" :value="1"></el-option>
        <el-option label="CPD" :value="2"></el-option>
        <el-option label="通用" :value="3"></el-option>
      </el-select>
      <search-slot-type-select v-model="tableParams.slotTypeId" />
      <el-select
        v-model="tableParams.isShow"
        clearable
        placeholder="选择是否展示"

      >
        <el-option value="1" label="是"></el-option>
        <el-option value="0" label="否"></el-option>
      </el-select>

      <search-budget-type v-model="tableParams.budget" />
      <el-input
        v-model="tableParams.importerName"

        placeholder="请输入导入信息"
      />

      <base-date-picker
        :defaultDate="defaultDate"
        @changeDate="changeDate"
        style="margin-right: 15px"
      />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="handleShowChange(1, tableSelect, 2)"
          type="success"
          size="mini"
        >批量展示</el-button
        >
        <el-button
          @click="handleShowChange(0, tableSelect, 2)"
          type="warning"
          size="mini"
        >批量隐藏</el-button
        >
        <el-upload
          :action="$baseURL + 'report/ledger/import/data'"
          :headers="header"
          :show-file-list="false"
          :on-progress="onLoading"
          :on-success="onSuccess"
        >
          <el-button
            v-loading.fullscreen.lock="loading"
            type="primary"
            size="mini"
            style="margin-left: 10px"
          >导入</el-button
          >
        </el-upload>
        <el-button
          @click="
            downExcel('/report/ledger/list/xlsx', '结算数据报表', downParam)
          "
          type="warning"
          size="mini"
          style="margin-left: 10px"
        >下载</el-button
        >
        <el-button @click="synchronization" type="warning" size="mini"
        >同步数据设置</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="showTableData"
        height="80vh"
        @select-all="handleTableSelectionChange"
        @select="oneChange"
        :header-cell-style="{ background: '#fafafa' }"
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        size="small"
        ref="table"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column type="selection"></el-table-column>
        <template v-for="(v, i) in checkColumns" :key="i">
          <el-table-column
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            align="center"
            :sortable="
              v.field === 'reportDate' ||
              v.field === 'slotId' ||
              v.field === 'profit' ||
              v.field === 'profitRate' ||
              v.field === 'showSmtExpected' ||
              v.field === 'clkSmtExpected' ||
              v.field === 'setShowName' ||
              v.field === 'expensesExpectedEcpm' ||
              v.field === 'incomeExpected' ||
              v.field === 'incomeExpectedEcpm' ||
              v.field === 'expensesExpected' ||
              v.field === 'importerName'
            "
          >
            <template v-slot="scope">
              <div v-if="v.field === 'showSmtExpected'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.showSmt }}
                </div>
                <div>{{ scope.row.showSmtExpected }}</div>
              </div>
              <div v-else-if="v.field === 'clkSmtExpected'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.clkSmt }}
                </div>
                <div>{{ scope.row.clkSmtExpected }}</div>
              </div>
              <div v-else-if="v.field === 'settlementType'">
                <div>
                  {{ settlementTypeMap[scope.row[v.field]] }}
                  <span v-if="scope.row[v.field] == 0">{{
                      "：" + scope.row["lowPrice"] + "分"
                    }}</span>
                </div>
                <!-- <div>{{scope.row.settlementType?scope.row.settlementType:'-'}}</div> -->
              </div>
              <!-- <div v-else-if="v.field === 'downSmt'">
                <div style="color:rgb(169 169 169)">{{ scope.row.downSmt }}</div>
                <div>{{ scope.row.downSmtExpected }}</div>
              </div> -->
              <div v-else-if="v.field === 'setShowName'">
                <div>{{ scope.row.setShowName }}</div>
                <div>{{ scope.row.setShowTime }}</div>
              </div>
              <div v-else-if="v.field === 'importerName'">
                <div>{{ scope.row.importerName }}</div>
                <div>{{ scope.row.importerTime }}</div>
              </div>
              <div v-else-if="v.field === 'incomeExpected'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.income }}
                </div>
                <div>{{ scope.row.incomeExpected }}</div>
              </div>
              <div v-else-if="v.field === 'expensesExpected'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.expenses }}
                </div>
                <div>{{ scope.row.expensesExpected }}</div>
              </div>
              <div v-else-if="v.field === 'expensesExpectedEcpm'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.expensesEcpm }}
                </div>
                <div>{{ scope.row.expensesExpectedEcpm }}</div>
              </div>
              <div v-else-if="v.field === 'incomeExpectedEcpm'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.incomeEcpm }}
                </div>
                <div>{{ scope.row.incomeExpectedEcpm }}</div>
              </div>
              <div v-else-if="v.field === 'profitExpected'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.profit }}
                </div>
                <div>{{ scope.row.profitExpected }}</div>
              </div>
              <div v-else-if="v.field === 'profitRate'">
                <div style="color: rgb(169 169 169)">
                  {{ scope.row.profitRate }}
                </div>
                <div>{{ scope.row.profitRateExpected }}</div>
              </div>
              <span v-else-if="v.field === 'budgetNameIdList'">
                <template
                  v-if="
                    scope.row.budgetNameIdList &&
                    scope.row.budgetNameIdList.length
                  "
                >
                  <el-popover placement="left" trigger="hover">
                    <template #reference>
                      <span
                        :style="{
                          color: 'rgb(75, 75, 227)',
                          cursor: 'pointer',
                        }"
                      >查看</span
                      >
                    </template>
                    <el-tag
                      v-for="item in scope.row.budgetNameIdList"
                      :key="item.budgetId"
                      :style="{ marginRight: '10px', marginBottom: '5px' }"
                    >
                      {{ item.budgetName }}
                    </el-tag>
                  </el-popover>
                </template>
                <span v-else>-</span>
              </span>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column
          label="展示状态"
          align="center"
          fixed="right"
          width="80"
        >
          <template v-slot="scope" align="center">
            <el-switch
              v-model="scope.row.isShow"
              @change="
                (state) => {
                  handleShowChange(state, [scope.row], 1);
                }
              "
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button
              @click="handleSetting(scope.row)"
              :disabled="scope.row.isShow ? true : false"
              type="primary"
              size="mini"
            >设置</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[30, 60, 100, 500, 1000, 2000, pagination.total]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>

    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="dialogClose"
      title="广告比例设置"
      :width="500"
      append-to-body
    >
      <el-form
        :model="auditForm"
        :rules="rules"
        hide-required-asterisk
        ref="form"

        label-position="left"
      >
        <el-form-item prop="incomeExpected">
          <template v-slot:label>
            <div class="form-item__label" style="line-height: 35px">
              原始收入：
            </div>
          </template>
          <el-input
            v-model="auditForm.incomeExpected"
            type="number"

            style="width: 50%"
            placeholder="请输入扣量比例"
          />
          <span style="margin-left: 10px"
          >支出：<span style="color: rgb(215 92 92)">{{
              revenue
            }}</span></span
          >
        </el-form-item>
        <div style="margin-bottom: 20px">
          支出ecpm：<span style="color: rgb(215 92 92)">{{ ecpmNum }}</span>
        </div>
        <el-form-item prop="percentage">
          <template v-slot:label>
            <div class="form-item__label">分成比例</div>
          </template>
          <el-input
            v-model="auditForm.percentage"
            type="number"

            placeholder="请输入分成比例"
          />
        </el-form-item>
        <el-form-item prop="deduction">
          <template v-slot:label>
            <div class="form-item__label">扣量比例</div>
          </template>
          <el-input
            v-model="auditForm.deduction"
            type="number"

            placeholder="请输入扣量比例"
          />
        </el-form-item>
      </el-form>

      <div style="text-align: right">
        <el-button @click="dialogClose" >取消</el-button>
        <el-button @click="setSubmit" type="primary"
        >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      v-model="dialogStatus2"
      @close="close"
      title="错误信息"
      :width="600"
      append-to-body
    >
      <p v-html="msg" style="color: #cfbb2b"></p>
      <el-button @click="close"  style="margin-top: 20px"
      >关闭</el-button
      >
    </el-dialog>
    <el-dialog
      v-model="dialogStatus3"
      @close="close2"
      title="同步设置"
      :center="true"
      :width="450"
      append-to-body
    >
      <el-date-picker
        v-model="date"
        @change="changeDate2"
        style="width: 100%; margin-bottom: 10px"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        :editable="false"
      >
      </el-date-picker>
      <div>
        <span style="margin-right: 10px">结算方式：</span>
        <el-radio-group v-model="synchroDate.synchronousType">
          <el-radio :label="1">CPM</el-radio>
          <el-radio :label="2">CPD</el-radio>
          <el-radio :label="3">CPA</el-radio>
          <el-radio :label="4">全部</el-radio>
        </el-radio-group>
      </div>

      <div style="margin-top: 20px; text-align: center">
        <el-button @click="close2" >取消</el-button>
        <el-button @click="syncSubmit"  type="primary"
        >确认同步</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import TableColumn from '@/components/TableColumn'
import initTableMixin from '@/mixins/initTable'
import SearchBudgetType from '@/components/SearchBudgetType'
import { downExcelMixin } from '@/mixins/downExcel'
import { setShow, deduction, getSchedule, setSynch } from '@/api/manage/account/statement' // ledgerImpor
import { appTypeMap } from '@/const/app-type'
import { settlementTypeMap } from '@/const/settlement-type.js'
import { formatDate, SIMPLE_MONTH_PATTERN } from '@/util/format'
// import { computed } from '@vue/runtime-core'

export default {
  name: 'Manage/account/statement',
  components: {
    SearchChannelSelect,
    SearchSlotTypeSelect,
    SearchChannelSlotSelect,
    SearchDspSlotSelect,
    SearchDspSelect,
    BaseDatePicker,
    SearchBudgetType,
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      tableSelect: [],
      columns: [
        { field: 'reportDate', title: '时间' },
        { field: 'channelName', title: '渠道名称' },
        { field: 'dspName', title: 'DSP 名称' },
        { field: 'dspSlotName', title: 'DSP 广告位' },
        { field: 'dspSlotCode', title: 'DSP 广告位code' },
        { field: 'slotId', title: '广告位编号' },
        { field: 'slotName', title: '广告位名称' },
        { field: 'budgetNameIdList', title: '预算类型' },
        { field: 'settlementType', title: '结算方式', width: 100 },
        { field: 'showSmtExpected', title: '展示数' },
        { field: 'clkSmtExpected', title: '点击数' },
        { field: 'expensesExpected', title: '支出' },
        { field: 'expensesExpectedEcpm', title: '支出Ecpm' },
        { field: 'incomeExpected', title: '收入' },
        { field: 'incomeExpectedEcpm', title: '收入Ecpm' },
        { field: 'profitExpected', title: '利润' },
        { field: 'profitRate', title: '利润率' },
        { field: 'setShowName', title: '修改信息', width: 90 },
        { field: 'importerName', title: '导入信息', width: 90 }
      ],
      header: {},
      appTypeMap,
      settlementTypeMap,
      showSmt: undefined,
      dialogStatus: false,
      dialogStatus2: false,
      dialogStatus3: false,
      date: [new Date(), new Date()],
      auditForm: {
        reportId: undefined,
        incomeExpected: undefined,
        deduction: undefined,
        percentage: undefined
      },
      synchroDate: {
        endTime: undefined,
        startTime: undefined,
        synchronousType: 1
      },
      rules: {
        deduction: [
          { required: true, message: '请输入扣量比例', trigger: 'blur' }
        ],
        incomeExpected: [
          { required: true, message: '请输入原始收入', trigger: 'blur' }
        ],
        percentage: [
          { required: true, message: '请输入分成比例', trigger: 'blur' }
        ]
      },
      loading: false,
      msg: undefined,
      defaultDate: [new Date(), new Date()],
      token: undefined,
      timeStart: undefined,
      myloading: undefined,
      showTableData: [],
      num: 0,
      timer: null
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
    this.changeDate2(this.date)
    this.token = JSON.parse(localStorage.getItem('adx-access_token')).content
    this.defaultDate = (() => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24)
      end.setTime(end.getTime() - 3600 * 1000 * 24)
      return [start, end]
    })()
  },
  computed: {
    ...mapGetters(['access_token']),
    revenue () {
      return (
        this.auditForm.incomeExpected * this.auditForm.percentage
      ).toFixed(2)
    },
    ecpmNum () {
      const sum =
        ((this.auditForm.incomeExpected * this.auditForm.percentage) /
          this.showNum) *
        1000
      return Math.floor(sum * 10000) / 10000
    },
    downParam () {
      const params = Object.assign({}, this.pagination, this.tableParams)
      delete params.total
      params.pageSize = this.pagination.total
      params.pageNum = 1
      return params
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
    this.tableDom()
    getSchedule().then((res) => {
      if (res.data.token) {
        if (this.token == res.data.token) {
          this.myloading = this.$loading({
            lock: true,
            text: '正在加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          this.timeStart = setInterval(() => {
            getSchedule().then((res) => {
              if (res.data.token) {
                this.myloading.setText('正在加载' + res.data.percentageSum + '%')
              } else {
                clearInterval(this.timeStart)
                this.myloading.close()
              }
            })
          }, 5000)
        }
      }
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/report/list'
      return true
    },
    afterInit (res) {
      this.tableData = res.data.records
      this.tableSelect = []// 清空选择的项
      document.querySelector('.el-table__body-wrapper').scrollTop = 0// 使下拉条回到顶部
      document.querySelector('.el-table__body').style.transform = 'translateY(0px)'// 使表格回到顶部

      // 使固定的列回到顶部
      document.querySelector('.el-table__fixed-body-wrapper .el-table__body').style.transform = 'translateY(0px)'

      const vheight = document.querySelector('#vheight')
      if (this.pagination.pageSize <= 60) {
        vheight.style.height = '0px'
        this.showTableData = this.tableData
        this.timer = true
      } else {
        // 使插入的元素高度变高，撑开表格，数字是每行高度，如果高度不确定，可取平均值以下
        vheight.style.height = this.tableData.length * 82 + 'px'
        // 截断的前50条数据放入tableData，交给table组件渲染
        this.$nextTick(() => { this.showTableData = this.tableData.slice(0, 50) })
        this.timer = null
      }
    },
    tableDom () {
      const i = document.createElement('i')
      i.id = 'vheight'
      i.style.width = '0'
      i.style.float = 'right'
      const dom = document.querySelector('.el-table__body-wrapper')
      dom.append(i)// 插入元素撑开表格
      document.querySelector('.el-table__body').style.float = 'left'// 将表格主体浮动

      dom.addEventListener('scroll', (v) => {
        const s = dom.scrollTop; const h = 85; let c
        // c做为判断拉动的距离有没有达到30条，我们每次取50条，留20条缓冲
        c = Math.floor(s / h) >= this.num && Math.floor(s / h) <= this.num + 30
        if (!this.timer && !c) {
          this.num = Math.floor(s / h)
          if (this.num <= this.pagination.total - 50) {
            document.querySelector('.el-table__body').style.transform = `translateY(${s}px)`
            document.querySelector('.el-table__fixed-body-wrapper .el-table__body').style.transform = `translateY(${s}px)`
            this.showTableData = this.tableData.slice(this.num, this.num + 50)
            this.showTableData.forEach((item) => {
              if (this.tableSelect.indexOf(item) !== -1) {
                this.$nextTick(() => {
                  this.$refs.table.toggleRowSelection(item)
                })
              }
            })
          } else {
            this.num = this.pagination.total - 30
            this.showTableData = this.tableData.slice(this.pagination.total - 50, this.pagination.total)
            this.showTableData.forEach((item) => {
              if (this.tableSelect.indexOf(item) !== -1) {
                this.$nextTick(() => {
                  this.$refs.table.toggleRowSelection(item)
                })
              }
            })
          }
        }
      })
    },
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    changeDate2 (date) {
      this.synchroDate.startTime = date[0] ? formatDate(date[0], SIMPLE_MONTH_PATTERN) : date[0]
      this.synchroDate.endTime = date[1] ? formatDate(date[1], SIMPLE_MONTH_PATTERN) : date[1]
    },
    onLoading () {
      this.loading = true
    },
    onSuccess (res) {
      this.loading = false
      if (res.code === 200) {
        this.$message({
          message: '已成功导入',
          type: 'success'
        })
        this.init()
      } else if (res.code === 5004) {
        const textList = res.msg.split('__')
        let text = ''
        for (let i = 0; i < textList.length; i++) {
          text = text + textList[i]
        }
        this.msg = text
        this.dialogStatus2 = true
      } else if (res.code === 5006) {
        this.dialogStatus2 = true
        const textList = res.msg.split(',')
        let text = ''
        for (let i = 0; i < textList.length; i++) {
          text = text + textList[i]
        }
        this.msg = text
      } else {
        this.$message.error(res.msg)
        this.init()
      }
    },

    handleTableSelectionChange (selection) {
      if (selection[0]) {
        this.tableSelect = this.tableData
      } else {
        this.tableSelect = []
      }
    },
    oneChange (selection, row) {
      if (this.tableSelect.indexOf(row) !== -1) {
        const data = []
        this.tableSelect.forEach((item) => {
          if (item !== row) {
            data.push(item)
          }
        })
        this.tableSelect = data
      } else {
        this.tableSelect.push(row)
      }
    },
    /**
     * @param { Number }state 状态值：1 展示，0 隐藏
     * @param { row }state 列表项
     * @param { Number }state 类型：1 开关控件提交，2 按钮控件提交
     */
    handleShowChange (state, row, type) {
      const data = []
      row.forEach((item) => {
        const obj = {
          dspSlotId: item.dspSlotId,
          appId: item.appId,
          dspId: item.dspId,
          channelId: item.channelId,
          reportId: item.reportId,
          isShow: state,
          reportDate: Number(item.reportDate),
          slotId: item.slotId,
          token: this.token
        }
        data.push(obj)
      })
      if (data.length < 1) return
      if (!data[0].slotId) return
      this.operation(data, type)
    },
    close () {
      this.dialogStatus2 = false
    },
    operation (data, type) {
      getSchedule().then((res) => {
        if (res.data.token) {
          this.$confirm(
            '当前' + res.data.operator + '在' + res.data.operatorDate + '处理,对方已加载' + res.data.percentageSum + '%',
            '是否进行排队',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.determine(data, type, 1)
            })
            .catch(() => {
              this.$message.error('已取消操作，修改展示状态失败')
              if (type === 1) {
                for (let i = 0; i < this.tableData.length; i++) {
                  if (this.tableData[i].reportId === data[0].reportId) {
                    this.tableData[i].isShow = this.tableData[i].isShow ? 0 : 1
                    return
                  }
                }
              }
            })
        } else {
          this.determine(data, type, 0)
        }
      })
    },
    determine (data, type, isWait) {
      this.myloading = this.$loading({
        lock: true,
        text: '正在加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (isWait || type == 2) {
        if (isWait) {
          let isOpen = true
          this.timeStart = setInterval(() => {
            getSchedule().then((res) => {
              if (res.data.token) {
                if (this.token == res.data.token) {
                  this.myloading.setText('正在加载' + res.data.percentageSum + '%')
                } else {
                  this.myloading.setText(
                    '请耐心等待，当前正在排队中，对方已加载' + res.data.percentageSum + '%'
                  )
                }
              } else {
                if (isOpen) {
                  this.openShow(data, type)
                  isOpen = false
                } else {
                  clearInterval(this.timeStart)
                }
              }
            })
          }, 5000)
        } else {
          this.openShow(data, type)
          this.timeStart = setInterval(() => {
            getSchedule().then((res) => {
              if (res.data.token) {
                if (this.token == res.data.token) {
                  this.myloading.setText('正在加载' + res.data.percentageSum + '%')
                } else {
                  this.myloading.setText(
                    '请耐心等待，当前正在排队中，对方已加载' + res.data.percentageSum + '%'
                  )
                }
              } else {
                clearInterval(this.timeStart)
              }
            })
          }, 5000)
        }
      } else {
        this.openShow(data, type)
      }
    },
    openShow (data, type) {
      setShow(data)
        .then((res) => {
          this.myloading.close()
          if (res.code === 200) {
            if (type === 2) {
              this.init()
            }
          }
        })
        .catch(() => {
          this.myloading.close()
          this.$message.error('修改展示状态失败')
          if (type === 1) {
            for (let i = 0; i < this.showTableData.length; i++) {
              if (this.showTableData[i].reportId === data[0].reportId) {
                this.showTableData[i].isShow = this.showTableData[i].isShow ? 0 : 1
                return
              }
            }
          }
        })
    },
    handleSetting (row) {
      this.dialogStatus = true
      this.auditForm.reportId = row.reportId
      this.auditForm.deduction = row.deduction || 0
      this.auditForm.percentage = row.dividedInto || 0
      this.auditForm.incomeExpected = row.incomeExpected || 0
      this.showNum = row.showSmtExpected
    },
    setSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          deduction(this.auditForm).then((res) => {
            if (res.code === 200) {
              this.dialogClose()
              this.init()
            }
          })
        }
      })
    },
    synchronization () {
      this.dialogStatus3 = true
    },
    syncSubmit () {
      this.close2()
      const syncLoading = this.$loading({
        lock: true,
        text: '请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setSynch(this.synchroDate).then((res) => {
        syncLoading.close()
        if (res.code == 200) {
          this.$message({
            message: '已成功同步',
            type: 'success'
          })
        }
      })
    },
    close2 () {
      this.dialogStatus3 = false
    },
    dialogClose () {
      this.dialogStatus = false
      this.auditForm = {
        reportId: undefined,
        incomeExpected: undefined,
        deduction: undefined,
        percentage: undefined
      }
    },
    tableSummary () {
      const arr = [
        'showSmtExpected',
        'clkSmtExpected',
        'expensesExpected',
        'expensesExpectedEcpm',
        'incomeExpected',
        'incomeExpectedEcpm',
        'profitExpected',
        'profitRate'
      ]
      const fixedArr = ['expensesExpected', 'incomeExpected', ]
      const fixed2Arr = ['expensesExpectedEcpm', 'incomeExpectedEcpm', 'profitRate','profitExpected']
      const data = this.tableData
      const checklists = this.checkColumns.map((item) => {
        return item.field
      })
      checklists.unshift('0')
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data
                  .reduce((total, item) => {
                    return total + Number(item[checklists[i]])
                  }, 0)
                  .toFixed(4)
                : '-'
          } else if (fixed2Arr.indexOf(checklists[i]) > -1) {
            if (checklists[i] == 'expensesExpectedEcpm') {
              out[i] = (
                (data.reduce((total, item) => {
                    return total + Number(item.expensesExpected)
                  }, 0) /
                  data.reduce((total, item) => {
                    return total + Number(item.showSmtExpected)
                  }, 0)) *
                1000
              ).toFixed(4)
            } else if (checklists[i] == 'incomeExpectedEcpm') {
              out[i] = (
                (data
                    .reduce((total, item) => {
                      return total + Number(item.incomeExpected)
                    }, 0)
                    .toFixed(4) /
                  data.reduce((total, item) => {
                    return total + Number(item.showSmtExpected)
                  }, 0)) *
                1000
              ).toFixed(4)
            } else if (checklists[i] == 'profitExpected'){
              out[i] = (
                (data
                    .reduce((total, item) => {
                      return total + Number(item.incomeExpected)
                    }, 0)
                    .toFixed(4) -
                  data.reduce((total, item) => {
                    return total + Number(item.expensesExpected)
                  }, 0))
              ).toFixed(4)
            }else {
              out[i] = (
                (data.reduce((total, item) => {
                    return total + Number(item.profitExpected)
                  }, 0) /
                  data.reduce((total, item) => {
                    return total + Number(item.incomeExpected)
                  }, 0) * 100).toFixed(2)
              )
            }
          } else {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data.reduce((total, item) => {
                  return total + Number(item[checklists[i]])
                }, 0)
                : '-'
          }
        }
      }
      return out
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}

// /deep/.el-table__body-wrapper {
//   order: 0;
// }
// /deep/.el-table__fixed-body-wrapper {
//    top: 62px !important;
// }
// /deep/.el-table__footer-wrapper tbody td{
//   border-bottom: none !important;
// }
// /deep/.el-table__header-wrapper tr th{
//   border-bottom: none !important;
// }
// /deep/.el-table__fixed-header-wrapper tr th{
//   border-bottom: none !important;
//   .cell{
//       word-break:normal;
//   }
// }
</style>
